import { useParams } from "react-router-dom"
import { useState,useEffect } from "react"
import Curriculum from "../../coursesview/Curriculum";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const PlayListCourseDetailPage = () => {
    const {id}=useParams()
    // console.log('The id is:',id)
    const [currentCourse,setCurrentCourse]=useState([])
    const [previewFile,setPreviewFile]=useState({type:'',file:''})
    useEffect(() => {
  const fetchCourse = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/courses/${id}/public/?learning_type=1`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );

      setCurrentCourse(res.data);
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  if (id) {
    fetchCourse();
  }
}, [id]);
      if(!currentCourse) return null
  return (
<div className=" min-h-screen">
  <div className="p-6 mx-auto">
    <div className="flex flex-col md:flex-row gap-8 items-start relative">
      
      {/* LEFT SIDE */}
      <div className="w-full md:w-1/2 space-y-6">
        {/* Course Image */}
        <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
          <img
            src={currentCourse.image}
            alt="Course Preview"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Course Title */}
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold text-gray-900">
            {currentCourse.name}
          </h1>
        </div>

        {/* Course Description */}
        <div className="pl-4">
          <p className="text-gray-600 leading-relaxed">
            {currentCourse.description}
          </p>
        </div>

        {/* Curriculum */}
        <div className="pt-4">
          <Curriculum
            currentCourse={currentCourse}
            setPreviewFile={setPreviewFile}
          />
        </div>
      </div>

      {/* RIGHT SIDE - Preview Panel */}
      <div className="w-full md:w-1/2 bg-white rounded-2xl border border-gray-200 shadow-sm
                      md:sticky md:top-[100px] md:max-h-[calc(100vh-100px)] md:overflow-y-auto">
        <div className="p-6">
          {previewFile.type === "video" ? (
            <video
              src={previewFile.file}
              controls
              poster={currentCourse.image}
              className="w-full rounded-xl border border-gray-200"
            />
          ) : previewFile.type === "audio" ? (
            <audio
              src={previewFile.file}
              controls
              className="w-full"
            />
          ) : ["pdf","doc","docx","ppt","pptx","txt","code"].includes(previewFile.type) ? (
            <iframe
              className="w-full h-[600px] rounded-xl border border-gray-200"
              src={
                previewFile.type === "pdf"
                  ? previewFile.file
                  : `https://docs.google.com/gview?url=${encodeURIComponent(previewFile.file)}&embedded=true`
              }
            ></iframe>
          ) : (
            <video
              src="/default-placeholder.mp4"
              controls
              poster={currentCourse.image}
              className="w-full rounded-xl border border-gray-200"
            />
          )}
        </div>
      </div>

    </div>
  </div>
</div>






  )
}

export default PlayListCourseDetailPage
